import Blue from '~/core';

new Blue({
	name: 'Market Accordion',
	selector: '.market-faq-section__accordion',
	setup(accordion) {
		const items = [...accordion.querySelectorAll('.market-faq-section__accordion-item')];
		const relations = [];

		items.forEach(container => {
			const trigger = container.querySelector('.market-faq-section__accordion-trigger');
			const content = container.querySelector('.market-faq-section__accordion-content');

			// attach accordion functionality
			const accordionInstance = new this.$toggle({
				container,
				trigger,
				content,
				relations,
			});

			relations.push(accordionInstance);

			// attach scroll functionality
			trigger.addEventListener('click', () => handleAccordionTriggerScroll());
			trigger.addEventListener('keydown', event => {
				const isEnterKey = event.key.toLowerCase() === 'enter';

				if (isEnterKey) handleAccordionTriggerScroll();
			});

			function handleAccordionTriggerScroll() {
				const triggerElement = container.querySelector('.market-faq-section__accordion-trigger');
				const triggerHeight = triggerElement.offsetHeight;

				setTimeout(() => {
					const topOffset = content.getBoundingClientRect().top + (window.scrollY - triggerHeight);

					window.scrollTo({ top: topOffset, behavior: 'smooth' });
				}, 500); // timeout is set to wait out the accordion collapse transition
			}
		});
	},
});
